import { logRetentionDays } from "./data/log-config.js";
import { loggingContexts } from "./data/logging-contexts.js";
import { log } from "./log.js";

const pruneLogFilesLog = log(loggingContexts.pruneLogs);

export const pruneLogFiles = async () => {
  const logFiles = await window.api?.readLogs?.();

  if (!logFiles) {
    return null;
  }

  if (logFiles.length <= logRetentionDays) {
    return 0;
  }

  const toDelete = logFiles.slice(0, logFiles.length - logRetentionDays);

  const results = await Promise.all(
    toDelete.map(async (logFile) => {
      const match = logFile.path.match(/(\d{4}-\d{2}-\d{2}\.log)$/);

      if (!match) {
        pruneLogFilesLog.warn(
          "skipping log file with unrecognized name pattern:",
          logFile.path
        );

        return false;
      }

      const [, filename] = match;

      pruneLogFilesLog.info("file to delete found:", filename);

      if (!window.api?.deleteLogFile) {
        return false;
      }

      try {
        await window.api.deleteLogFile({ filename });

        return true;
      } catch (error) {
        pruneLogFilesLog.warn(
          "could not delete log file:",
          filename,
          error?.message
        );

        return false;
      }
    })
  );

  return results.filter(Boolean).length;
};
